import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class PoTokenAuthService {
  private readonly tokenKey = 'poAccessToken';
  private readonly poIdKey = 'poId';

  set(poAccessToken: string, poId: string | number): void {
    if (poAccessToken) sessionStorage.setItem(this.tokenKey, poAccessToken);
    if (poId !== undefined && poId !== null) sessionStorage.setItem(this.poIdKey, String(poId));
  }

  clear(): void {
    sessionStorage.removeItem(this.tokenKey);
    sessionStorage.removeItem(this.poIdKey);
  }

  getToken(): string | null {
    return sessionStorage.getItem(this.tokenKey);
  }

  getPoId(): string | null {
    return sessionStorage.getItem(this.poIdKey);
  }

  buildAuthHeaders(): { headers: HttpHeaders } | {} {
    const token = this.getToken();
    if (!token) return {};
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token);
    return { headers };
  }
}

